import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Dashboard from '../components/Dashboard';
import Features from '../components/Features';
import HowItWorks from '../components/HowItWorks';
import Solutions from '../components/Solutions';
import CTA from '../components/CTA';
import About from '../components/About';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import Modals from '../components/Modals';

export default function HomePage({ onLogoClick }) {
  const [loginModalOpen, setLoginModalOpen] = React.useState(false);
  const [demoModalOpen, setDemoModalOpen] = React.useState(false);
  const [featureModalOpen, setFeatureModalOpen] = React.useState(false);

  return (
    <div id="home" style={demoModalOpen || loginModalOpen || featureModalOpen ? {overflow: 'hidden'} : {}}>
      <Header onOpenDemoModal={() => { console.log('DEMO MODAL OPENING'); setDemoModalOpen(true); }} onLogoClick={onLogoClick} />
      <Hero onOpenDemoModal={() => { console.log('DEMO MODAL OPENING'); setDemoModalOpen(true); }} />
      <Dashboard />
      <Features />
      <HowItWorks />
      <Solutions />
      <CTA onOpenDemoModal={() => { console.log('DEMO MODAL OPENING'); setDemoModalOpen(true); }} />
      <About />
      <Contact />
      <Footer />
      <Modals
        loginModalOpen={loginModalOpen}
        demoModalOpen={demoModalOpen}
        featureModalOpen={featureModalOpen}
        onCloseLoginModal={() => setLoginModalOpen(false)}
        onCloseDemoModal={() => setDemoModalOpen(false)}
        onCloseFeatureModal={() => setFeatureModalOpen(false)}
        onOpenLoginModal={() => setLoginModalOpen(true)}
        onOpenDemoModal={() => setDemoModalOpen(true)}
      />
    </div>
  );
}
